<template>
	<div class="flex items-center justify-between w-full h-128rpx relative nheader">
		<div class="absolute flex items-center justify-center left-30rpx">
			<div @click="goBack()" v-if="needBack == 1" class="flex items-center justify-center">
				<img class="w-40rpx h-40rpx" style="width: 20px;height: 20px;" src="@/assets/images/common/icon_back.png" alt="">
			</div>
		</div>
		<div class="flex-1 flex text-40rpx text-white items-center justify-center text-ellipsis nheadertit" :class="textColorClass">
			<slot>{{ title }}</slot>
		</div>
		<slot name="rightDom"></slot>
	</div>
</template>

<script>
import api from "@/request/api.js";
import store from '@/store/index.js';
import utils from "@/utils/utils.js";
export default {
	props: {
		title: {
			type: String,
			default: ''
		},
		needBack: {
			type: [Number, String],
			default: 1
		},
		textColorClass: {
			type: String,
			default: 'text-white'
		},
	},
	data() {
		return {

		};
	},
	created() { },
	methods: {
		goBack() {
			utils.goBack();
		}
	},
}
</script>

<style>
.nheader{
	position: relative;
	/* height: 40px; */
	min-height: 40px;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
}
.nheadertit{
	flex: auto;
	font-size: 18px;
	font-weight: 500;
	color: #fff;
}
</style>